import { RatingValues } from '@petconsole/pure-shared';

const totalRaters = (ratings: RatingValues) => ratings.reduce((sum, value) => sum + value, 0);

export default totalRaters;
